/**
 * Product Card Video Hover Functionality
 * Handles playing/pausing videos when hovering over product cards
 */

class VideoHoverPlayPause extends HTMLElement {
  #listenersAbort = new AbortController();

  connectedCallback() {
    queueMicrotask(() => this.#setup());
  }

  disconnectedCallback() {
    this.#listenersAbort.abort();
    this.#listenersAbort = new AbortController();
  }

  #setup() {
    const videoMedia = this.querySelector(
      "video-media.product-card__image--secondary",
    );
    const videoElement = this.querySelector("video");
    const figure = this.closest(".product-card__figure");
    const interactionSurface = figure ?? this.closest("a.product-card__media");

    if (!videoMedia || !videoElement || !interactionSurface) {
      return;
    }

    const { signal } = this.#listenersAbort;

    interactionSurface.addEventListener(
      "mouseenter",
      () => {
        videoMedia.play();
      },
      { signal },
    );

    interactionSurface.addEventListener(
      "mouseleave",
      () => {
        videoMedia.pause();
      },
      { signal },
    );

    let touchStartTime = 0;
    let touchStartY = 0;
    let touchStartX = 0;

    interactionSurface.addEventListener(
      "touchstart",
      (e) => {
        touchStartTime = Date.now();
        touchStartY = e.touches[0].clientY;
        touchStartX = e.touches[0].clientX;
      },
      { signal, passive: true },
    );

    interactionSurface.addEventListener(
      "touchend",
      (e) => {
        const touchEndTime = Date.now();
        const touchDuration = touchEndTime - touchStartTime;
        const touchEndY = e.changedTouches[0].clientY;
        const touchEndX = e.changedTouches[0].clientX;
        const touchDistance = Math.sqrt(
          Math.pow(touchEndX - touchStartX, 2) +
            Math.pow(touchEndY - touchStartY, 2),
        );

        if (touchDuration < 300 && touchDistance < 10) {
          videoMedia.play();

          setTimeout(() => {
            videoMedia.pause();
          }, 2000);
        }
      },
      { signal, passive: true },
    );
  }
}

if (!window.customElements.get("video-hover-play-pause")) {
  customElements.define("video-hover-play-pause", VideoHoverPlayPause);
}
